import { SearchPaperListPage } from './SearchPaperListPage';
export default SearchPaperListPage;